import { toUpper } from 'lodash';
import { sanitizeStrFromCenter } from './common';

export const collapseVin = sanitizeStrFromCenter(substr =>
  toUpper(substr.replace(/[^a-zA-Z\d]/g, '')),
);
